<template>
  <div class='container'
       ref="containerBox"
       @scroll="handleScroll">
    <div ref="stickyBox"
         :class="[{ sticky: isSticky }, { box: !isSticky }]"
         :style="{ background: isSticky ? '#fff' : 'transparent' }">
      <titlePage :isSticky="isSticky"
                 :scrollToTop="scrollToTop"></titlePage>
    </div>
    <div class='contentBox'>
      <!-- 轮播 -->
      <!-- <el-carousel :interval="5000" arrow="always" @change="changeBanner()">
                <el-carousel-item v-for="(item, index) in pc_banner" :key="index">
                    <el-image :src="item.src" style="width: 100%;height: auto;min-width: 1200px;"></el-image>
                </el-carousel-item>
            </el-carousel> -->
      <a-carousel dots-class="slick-dots slick-thumb"
                  autoplay
                  @beforeChange="changeBanner"
                  arrows>
        <div v-for="(item, index) in pc_banner"
             :key="index">
          <img :src="item.src"
               alt="carousel image"
               style="width: 100%;height: auto;min-width: 1200px;" />
        </div>
      </a-carousel>
      <div style="background:#fff;padding:120px 0 0 0;"
           class="flex-center">
        <!-- <WinningNotice ref="winningNotice" :newsList="newsList" /> -->
        <div style="border: 2px solid #0092FF;
    border-radius: 4px;display: flex;padding: 16px 20px 0 20px;box-sizing: border-box;"
             class="content">
          <div style="margin-right: 20px;">
            <el-image :src="require(`@/static/image/index/laba.png`)"
                      style="width: 12px ;height:12px ;"
                      fit="fill"></el-image>
          </div>
          <el-carousel :interval="2000"
                       arrow="always"
                       direction="vertical">
            <div class="flex">
              <el-carousel-item v-for="(item, index) in newsList"
                                :key="index"
                                style="flex:0 0 80%;margin-left: auto;">
                恭喜<span class="news-title">{{ item.company || '' }}</span>
                <span class="news-title">{{ item.nickname || '' }}</span>
                客户<span class="news-title">{{ item.customer || "" }}</span>
                于<span class="news-title">{{ item.pay_time || "" }}</span>产生了新的交付额 <span class="news-title price">￥{{ item.pay_fee || "" }}</span>
              </el-carousel-item>
            </div>
          </el-carousel>
        </div>
      </div>

      <!-- <div style="background: #fff;min-width: 1200px;padding:20px 20px 0 20px;border: 2px solid #0092FF;
    border-radius: 4px;display: flex;">
                <div>
                    <el-image :src="require(`@/static/image/index/laba.png`)" style="width: 12px ;height:12px ;"
                        fit="fill"></el-image>
                </div>
                <el-carousel :interval="2000" arrow="always" direction="vertical">
                    <div class="flex">
                        <el-carousel-item v-for="(item, index) in newsList" :key="index"
                            style="flex:0 0 80%;margin-left: auto;">
                            恭喜<span class="news-title">{{ item.company || '' }}</span>
                            <span class="news-title">{{ item.nickname || '' }}</span>
                            客户<span class="news-title">{{ item.customer || "" }}</span>
                            于<span class="news-title">{{ item.pay_time || "" }}</span>产生了新的交付额 <span
                                class="news-title price">￥{{ item.pay_fee || "" }}</span>
                        </el-carousel-item>
                    </div>
                </el-carousel>
            </div> -->
      <!-- 搜索 -->
      <!-- <div style="background:#fff;padding:20px 0;min-width: 1200px;" class="flex-center">
                <el-input placeholder="请输入内容" v-model="keyword" class="input-with-select"
                    style="width: 50%;border:2px solid #0092FF;border-radius: 4px;">
                    <template slot="prepend">
                        <div class="cursor" @click="dialogVisible = true">{{ select || '全国' }}<i
                                class="el-icon-caret-bottom"></i></div>
                    </template>
<el-button slot="append" icon="el-icon-search" type="primary" style="background: #0092FF;color: #fff;"
    @click="getList">搜索</el-button>
</el-input>
</div> -->
      <notice-page></notice-page>
      <div class="content"
           style="padding:20px 0;">
        <div class="flex-between"
             style="align-items: center;">
          <div class="list-box"
               style="flex:0 0 50%">
            <div class="list-item flex-center LeftContentItem cursor boxShadow"
                 style="flex-direction: column;"
                 v-for="(item, index) in cate"
                 :key="index"
                 @click="getMore(item)">
              <el-image :src="item.src"
                        style="width: 36px;height: 36px;margin-bottom: 18px;"
                        fit="fill"></el-image>
              <p>{{ item.cate_name }}</p>
            </div>
          </div>
          <!-- <el-image :src="src" style="width: 680px;border-radius: 6px;" fit="fill"></el-image> -->
          <el-image :src="pc_adv.src"
                    style="width: 48%;border-radius: 6px;max-width: 680px;height: 300px;"
                    fit="fill"
                    v-if="pc_adv.src"></el-image>
        </div>
        <div class=""
             style="margin-top: 30px;background:#fff ;padding: 20px 20px 10px 50px;">
          <el-tabs v-model="activeName"
                   @tab-click="handleClick">
            <el-tab-pane :label="item.title"
                         :name="item.title"
                         v-for="(item, index) in order_cate"
                         :key="index"></el-tab-pane>
          </el-tabs>
        </div>
        <div class="list-box"
             style="margin-top: 30px;"
             v-loading="loading">
          <div class="list-item cursor items boxShadow"
               style="display: flex; flex-direction: column;padding: 0;"
               v-for="(item, index) in list"
               :key="index"
               @click="getDetailes(item)">
            <div class="card">
              <div class="flex-between">
                <div class="title slh">{{ item.title || '' }}</div>
                <el-button type="primary"
                           size="mini"
                           @click.stop="getOrder(item)">立即接单
                </el-button>
              </div>
              <div class="flex"
                   style="margin-top: 2px;">
                <div class="tag">{{ item.city_name || '' }}</div>
                <div class="tag">招{{ item.people || 0 }}人</div>
              </div>
              <div style="margin-top: 10px;"
                   class="PriceText"> {{ item.pay || '' }} </div>
              <div style="margin-top: 10px;"
                   class="flex-between">
                <div class="text"> {{ item.company || '' }}</div>
                <!-- <div class="text"
                     style="color: #999;">{{ item.create_time || '' }}</div> -->
              </div>
            </div>
            <div class="GradientBackground flex-between"
                 style="border-radius: 0 0 10px 10px;">
              <div>{{ item.pay_list || '' }}</div>
              <div class="price"><span>推荐</span><span style="color:#ff1f34;font-size: 16px;font-weight: bold;">{{item.pay_list||''}}</span><span>1人最高奖励</span> <span style="color:#ff1f34;font-size: 16px;font-weight: bold;">{{ item.pay_fee || 0 }}元</span></div>
            </div>
          </div>
        </div>
      </div>
      <div style="margin-top: 50px;"
           class="flex-center">
        <el-button type="primary"
                   plain
                   @click="getMore">查看更多</el-button>
      </div>
    </div>

    <!-- <div class="popupBox" v-if="isShowPopup && closeBox">
            <popup @close="close"></popup>
        </div> -->
    <!-- <popup v-if="!token && closeBox" @close="close"></popup> -->
    <fotterVue></fotterVue>
    <el-dialog title="城市"
               :visible.sync="dialogVisible"
               width="800px"
               :before-close="handleClose">
      <cityPage @changeCity="changeCity" />
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="submit">确 定</el-button>
      </span>
    </el-dialog>
    <TrialExpireRemindHost page-key="homePage" />
  </div>
</template>

<script>
import config from '@/config/config'
import titlePage from '@/components/titlePage.vue'
import fotterVue from '@/components/fotter.vue'
import cityPage from '@/components/cityPage.vue'
import noticePage from '@/components/noticePage.vue'
import TrialExpireRemindHost from '@/components/TrialExpireRemindHost.vue'
// import popup from '@/components/popup.vue';
import { Carousel } from 'ant-design-vue'
import { StarFilled } from '@ant-design/icons'
// import WinningNotice from '@/components/WinningNotice'
export default {
  name: '',
  components: {
    titlePage,
    fotterVue,
    cityPage,
    noticePage,
    'a-carousel': Carousel,
    TrialExpireRemindHost,
    // popup,
    // WinningNotice,
  },
  data() {
    return {
      src: 'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg',
      keyword: '',
      typeList: [
        // { name: "销售人员", src: "image/index/icon1" },
        { name: '销售人员', src: 'require(`@/static/image/index/icon1.png`)' },
        { name: '软件开发', src: 'require(`@/static/image/index/icon2.png`)' },
        { name: '客服运营', src: 'require(`@/static/image/index/icon3.png`)' },
        { name: '市场推广', src: 'require(`@/static/image/index/icon4.png`)' },
        { name: '行政财务', src: 'require(`@/static/image/index/icon5.png`)' },
        { name: '教育行业', src: 'require(`@/static/image/index/icon6.png`)' },
      ],
      activeName: '',
      ininin: 1,
      select: '',
      order_cate: [],
      pc_banner: [],
      pc_adv: {},
      cate: [],
      order_cate_id: '',
      list: [],
      loading: false,
      isSticky: false,
      stickyBoxTop: 0,
      dialogVisible: false,
      carouselHeight: null,
      currentIndex: 0,
      isShowPopup: false,
      newsList: [],
      token: localStorage.getItem('token') || '',
      closeBox: true,
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.select = localStorage.getItem('cityName')
    this.scrollToTop()
    this.loading = true
    this.getDate()
  },
  methods: {
    changeBanner(currentIndex) {
      // console.log(currentIndex , 'uuuuu carouselHeight');
    },
    handleScroll(event) {
      const scrollTop = event.target.scrollTop
      this.isSticky = scrollTop > this.stickyBoxTop
      const bottomOfWindow =
        this.$refs.containerBox.scrollHeight -
        this.$refs.containerBox.scrollTop -
        this.$refs.containerBox.clientHeight
      if (this.token) {
        this.isShowPopup = false
      } else {
        // if (this.closeBox) {
        if (this.$refs.containerBox.scrollTop == 0 || bottomOfWindow < 500) {
          this.isShowPopup = false
        } else {
          this.isShowPopup = true
        }
        // } else {
        //     this.isShowPopup = false
        // }

        // if (this.$refs.containerBox.scrollTop == 0 || bottomOfWindow < 500) {
        //     this.isShowPopup = false
        // } else {
        //     if (this.closeBox) {
        //         this.isShowPopup = true
        //     }
        // }
      }
    },
    scrollToTop() {
      this.$refs.containerBox.scrollTop = 0
    },
    handleClick(tab, event) {
      console.log(tab, event)
      console.log(event.target.innerText)
      // this.innerText
      let data = this.order_cate.filter((item) => {
        return item.title == event.target.innerText
      })
      console.log(data, 'data')
      this.activeName = data[0].title
      this.order_cate_id = data[0].id
      this.list = []
      this.loading = true
      this.getList()
    },
    getDetailes(item) {
      this.$router.push({
        path: '/RecruitmentDetails',
        query: {
          id: item.id,
        },
      })
    },
    getMore(item) {
      // this.$router.push('/RecruitmentOrder')
      // this.$parent.scrollToTop()
      this.$router.push({
        path: '/RecruitmentOrder',
        query: {
          cate_id: item.cate_id,
        },
      })
    },

    getDate() {
      this.$api.index.getInfo().then((res) => {
        if (res.code == 200) {
          this.order_cate = res.data.order_cate
          this.activeName = this.order_cate[0].title
          this.order_cate_id = this.order_cate[0].id
          this.pc_banner = res.data.pc_banner.map((item) => {
            item.src = config.config + item.pic
            return item
          })
          this.pc_adv = res.data.pc_adv.map((item) => {
            item.src = config.config + item.pic
            return item
          })[0]
          this.newsList = res.data.carousel || []
          this.cate = res.data.cate
            .map((item) => {
              item.src = config.config + item.cate_pc_thumb
              return item
            })
            .slice(0, 6)
          // 列表
          this.getList()
        }
      })
    },
    getList() {
      let data = {
        page: 1,
        size: 6,
        keyword: this.keyword,
        order_cate_id: this.order_cate_id,
      }
      this.$api.index.getIndexList(data).then((res) => {
        this.loading = false
        if (res.code == 200) {
          this.list = res.data.list || []
        }
      })
    },
    getOrder(item) {
      console.log(item)
      this.$api.index.getOrder({ id: item.id }).then((res) => {
        this.loading = false
        if (res.code == 200) {
          this.$message.success('接单成功')
        }
      })
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          done()
        })
        .catch((_) => {})
    },
    changeCity(item) {
      localStorage.setItem('cityId', item.id)
      localStorage.setItem('cityName', item.title)
      console.log('changeCity', item, localStorage.getItem('cityId'))
    },
    submit() {
      this.select = localStorage.getItem('cityName')
      this.dialogVisible = false
      // this.getDate()
      this.$router.go(0)
    },
    close() {
      this.closeBox = false
      console.log(this.closeBox, 'closeBoxcloseBox')
    },
  },
}
</script>
<style lang='scss' scoped>
.contentBox {
  background: #f6f8fe;
  padding-bottom: 50px;
}

::v-deep .el-carousel__container {
  // height: 530px;
  // height: auto;
}

.serchBox {
  width: 905px;
  border: 2px solid #0092ff;
  border-radius: 6px;
  margin: 0 auto;
}

.text {
  font-weight: 500;
  font-size: 14px;
  color: #333333;
}

.popup-items {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-right: 2px;

  font-weight: bold;
  font-size: 16px;
  color: #ffffff;

  p {
    margin-top: 3px;
  }
}

.leftcontent {
  font-weight: 500;
  font-size: 12px;
  color: #ffffff;
  border-right: 1px solid rgba(255, 255, 255, 0.17);
}

.rightcontent {
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;

  .bottom-items {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
  }

  .bottom-text {
    line-height: 30px;
  }
}

.logoText {
  font-size: 27px;
}

::v-deep .el-tabs__nav-wrap::after {
  background-color: transparent !important;
}

::v-deep .el-select .el-input {
  width: 120px;
}

.list-item {
  max-width: calc((100% - 48px) / 3);
}

::v-deep .el-input-group__prepend {
  background-color: transparent !important;
}

.items {
  margin-right: 24px !important;

  &:nth-child(3n + 1) {
    margin-right: 0 !important;
  }
}

::v-deep .el-input-group__append {
  // background: rgb(42, 163, 254) !important;
  position: relative;
  width: 90px;

  .el-button {
    position: absolute;
    // top: 10px;
    // margin-top: -10px;

    top: 7px;
    right: 19px;
    height: 44px;
    width: 91px;
  }
}

.popupBox {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  opacity: 0;
}

::v-deep .el-carousel__container {
  height: 40px !important;
}

::v-deep .el-carousel--vertical {
  min-width: 1200px;
  width: 50%;
  margin: 0 auto;
}

::v-deep .el-carousel__item {
  width: 80% !important;
}
</style>